import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Project from "./Pages/Projects/Project";
import ErrorPage from "./ErrorPage";
import About from "./Pages/About/About";
import Prasang from "./Pages/Prasang";
import LobbyLightAutomation from "./Pages/LobbyLightAutomation";
import TankAlert from "./Pages/TankAlert";
import ProjectInfoPage from "./Pages/projectInfoPage";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/Projects" element={<Project />} />
      <Route path="/About" element={<About />} />
      <Route path="/Projects/PrasangWebsite" element={<Prasang />} />
      <Route
        path="/Projects/LobbyLightAutomation"
        element={<ProjectInfoPage ProjectName="Lobby Light Automation" ProjectLink="https://www.youtube.com/embed/-I0ZLpEZZE4?si=5qs1Kbie9SAF0L5P" />}
      ></Route>
      <Route path="/Projects/TankAlerter" element={<ProjectInfoPage ProjectName="Tank Alerter" ProjectLink="https://www.youtube.com/embed/LUypH4ujBbE?si=mKb4qDUifj2U4b-m" />}></Route>
      <Route path="/Projects/TodoList" element={<ProjectInfoPage ProjectName="Todo List" ProjectLink="" />}></Route>
      <Route path="/Projects/KrimDesktopAssistant" element={<ProjectInfoPage ProjectName="Krim Desktop Assistant" ProjectLink="https://www.youtube.com/embed/b9kobhzt5QI?si=Lgv01ZifGsdoFP0t" />}></Route>
      <Route path="/Projects/MonkeytypeAutomation" element={<ProjectInfoPage ProjectName="Monkey Type Automation" ProjectLink="https://www.youtube.com/embed/7qvWJsmgIII?si=dj1qcVOa2wbp8Y2v" />}></Route>
      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
